import Tasks from "./Tasks";
import Vaccines from "./Vaccines";
import CostCenterMaintenance from "./costCenter/CostCenterMaintenance";
import CountryMaintenance from "./location/CountryMaintenance";
import DepartmentMaintenance from "./location/DepartmentMaintenance";
import MunicipalityMaintenance from "./location/MunicipalityMaintenance";

const HeadcountRouter = [
  {
    type: "private",
    path: "/country-maintenance",
    roles: ["administrador"],
    component: CountryMaintenance,
    exact: true,
  },
  {
    type: "private",
    path: "/department-maintenance",
    roles: ["administrador"],
    component: DepartmentMaintenance,
    exact: true,
  },
  {
    type: "private",
    path: "/municipality-maintenance",
    roles: ["administrador"],
    component: MunicipalityMaintenance,
    exact: true,
  },
  {
    type: "private",
    path: "/tareas/:type",
    roles: ["administrador"],
    component: Tasks,
    exact: true,
  },
  {
    type: "private",
    path: "/mantenimiento-vacunas/:type",
    roles: ["administrador"],
    component: Vaccines,
    exact: true,
  },
  {
    type: "private",
    path: "/cost-center-maintenance",
    roles: ["administrador"],
    component: CostCenterMaintenance,
    exact: true,
  },
];

export default HeadcountRouter;
